// Plain design-data tokens shared by the theme and any component that needs
// raw values outside of `sx`/MUI (e.g. custom CSS, canvas/chart colors).

export const zIndex = {
  overlay: 1400, // above the floating bottom nav and any open Dialog
};

// Values are px strings, not bare numbers: MUI's `sx` borderRadius shorthand
// multiplies numeric values by `theme.shape.borderRadius` (e.g. `sx={{
// borderRadius: 2 }}` => 2 * theme.shape.borderRadius), which would silently
// break these into huge/wrong radii. Strings bypass that multiplier and are
// used as literal CSS.
export const radius = {
  xs: '6px',
  sm: '8px',
  md: '12px',
  lg: '16px',
  xl: '24px',
  pill: '999px',
};

// Meal accent colors are intentionally the same in light and dark mode —
// they're used as small identity accents (dots, chips), not surfaces, so a
// single hue per meal reads fine on either background.
export const colors = {
  meal: {
    breakfast: '#FDD835',
    lunch: '#26C6DA',
    dinner: '#AB47BC',
    snacks: '#FFA726',
  },
  // Historically re-purposed from meal colors (dinner->protein, lunch->carbs,
  // snacks->fat) — kept identical to avoid an unrelated visual change.
  macro: {
    protein: '#AB47BC',
    carbs: '#26C6DA',
    fat: '#FFA726',
  },
  streak: {
    current: '#FF5722',
    best: '#4CAF50',
  },
  goal: {
    aggressive: '#EF5350',
    moderate: '#FFA726',
    maintain: '#66BB6A',
  },
  gender: {
    female: '#EC4899',
  },
  brand: {
    gradientStart: '#667eea',
    gradientEnd: '#764ba2',
  },
  celebration: {
    gradientStart: '#69f0ae',
    gradientEnd: '#00c853',
  },
};

const tokens = { radius, colors, zIndex };

export default tokens;
